export default __webpack_public_path__ + "static/media/gegg-min.51eba144.png";